export const DESIGN_CONTROLS_SOURCE = "product-development";

export const isSoureEditableAndDeletable = (source: string) => {
  return [DESIGN_CONTROLS_SOURCE, "qualio"].includes(source);
};
